import Bugsnag from '~/lib/bugsnag'
import React, { Fragment, ReactNode } from 'react'
import ErrorPage from '~/pages/_error'

const plugin = Bugsnag.getPlugin('react')
const ErrorBoundary = plugin?.createErrorBoundary(React) ?? Fragment
export const BugsnagErrorBoundary = ({ children }: { children: ReactNode }) => (
  <ErrorBoundary FallbackComponent={ErrorPage}>{children}</ErrorBoundary>
)
